import $ from "jquery";
/**
 * The PubSub class. This class will manage the application-wide topics that code
 * has registered callbacks to.
 *
 * @class
 */
const PubSub = function () {
    const self = this;
    let topics = {};

    /**
     * @constructor
     * @this Topic
     * Creates an instance of a topic, which will allow consumers to register callback
     * functions that should execute whenever the topic receives a "publish" event.
     * @param {string} id The string that represents the unique name of the topic.
     * @return {Topic} an object that will contain three methods to interact with topics:
     *                 publish, subscribe, and unsubscribe.
     */
    self.Topic = function (id) {
        if (!id) {
            return undefined;
        }

        let callbacks,
            topic = id && topics[id];

        if (!topic) {
            callbacks = $.Callbacks();
            topic = {
                /**
                 * https://api.jquery.com/callbacks.has/
                 *
                 * NOTE: Even though it is not documented, it is valid to check callbacks.has() without a parameter. It will
                 * return true if there are ANY registered callbacks.
                 *
                 */
                has: callbacks.has,

                /**
                 * Execute all of the callback functions that are registered with the
                 * current topic.
                 * @param {arguments} A set of arguments that will be passed into each
                 *                    callback function.
                 */
                publish: callbacks.fire,

                /**
                 * Subscribe a callback functions to the topic.
                 * @param {function|Array} callbacks A function, or array of functions,
                 *                                   that are to be added to the callback
                 *                                   list.
                 */
                subscribe: callbacks.add,

                /**
                 * Remove a callback or a collection of callbacks from the topic's
                 * callback list.
                 * @param {function|Array} callbacks A function, or array of functions,
                 *                                   that are to be removed from the
                 *                                   callback list.
                 */
                unsubscribe: callbacks.remove,
            };

            topics[id] = topic;
        }
        return topic;
    };

    self.clearTopic = function (id) {
        if (topics[id] !== undefined) {
            delete topics[id];
        }
    };

    self.clearAllTopics = function () {
        for (const key in topics) {
            delete topics[key];
        }

        topics = {};
    };
};

/**
 * A singleton instance of {AppView} that manages
 * high-level application UI state.
 * @exports viewModels/appView
 */

export default new PubSub();
